import type {
  EstadoProyecto,
  ProgresoGeneracion as ProgresoGeneracionTipo,
} from "../api/types";
import estilos from "./ProgresoGeneracion.module.css";

interface Props {
  estado: EstadoProyecto;
  progreso: ProgresoGeneracionTipo | null;
}

// Barra de progreso agentico por sondeo (adapta ProgresoAgentico del
// hermano a un solo lienzo estatico): el backend publica {stage, pct,
// mensaje} mientras `run_flyer_generation` corre (pipeline/flyer_agentic.py,
// on_progress), y GET /projects/{id} lo expone para que la UI lo sondee via
// useProyecto. Sin `progreso` todavia (el hilo de generacion recien
// arranco) mostramos una barra indeterminada.
export function ProgresoGeneracion({
  estado,
  progreso,
}: Props): JSX.Element | null {
  if (estado !== "generando") return null;

  const pct =
    progreso && Number.isFinite(progreso.pct)
      ? Math.round(progreso.pct * 100)
      : null;
  const mensaje = progreso?.mensaje ?? progreso?.stage ?? "Preparando...";

  return (
    <div
      className={estilos.contenedor}
      role="status"
      aria-live="polite"
      aria-labelledby="titulo-progreso-generacion"
    >
      <div className={estilos.encabezado}>
        <h4 id="titulo-progreso-generacion">Generando el flyer</h4>
        <span className={estilos.aviso}>
          Este proceso puede tardar varios minutos.
        </span>
      </div>
      <div className={estilos.barra}>
        <div
          className={`${estilos.relleno} ${pct === null ? estilos.indeterminado : ""}`}
          style={pct !== null ? { width: `${pct}%` } : undefined}
        />
      </div>
      <p className={estilos.mensaje}>
        {mensaje}
        {pct !== null ? ` (${pct}%)` : ""}
      </p>
    </div>
  );
}
